import React from 'react';
import {useDelete, useRefresh, useNotify} from 'react-admin';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import SmsIcon from "@material-ui/icons/Sms";
import {Link} from 'react-router-dom';

export const ChatterBulkButton = (props) => {
    return <Button
        variant="outlined"
        color="secondary"
        startIcon={<SmsIcon/>}
        component={Link}
        to={{
            pathname: '/chatter',
            state: props.selectedIds,
            basePath: props.basePath,
        }}
        style={{overflow: 'inherit'}}
    >Chatter</Button>
};
